module.exports = __webpack_public_path__ + "img/england.ceb03109.svg";